import { cn } from 'util/cn'

import { css } from 'design'
import { useTheme } from 'design/use_theme'
import { Stack } from 'primitives/containers'
import React from 'react'
import { useSelector } from 'react-redux'

import { getSelectedWelcomeMessage } from '../../reduxes/slices/welcome_messages/selectors'

type Props = {
  children: any
  videoVariant?: boolean
}

export const WidgetPageContainer = ({
  children,
  videoVariant = true,
}: Props) => {
  const welcomeMessage = useSelector(getSelectedWelcomeMessage)
  const [theme] = useTheme()

  return welcomeMessage && videoVariant ? (
    <div className={containerStyles()}>{children}</div>
  ) : (
    <Stack
      className={cn(
        widgetBGStyles(),
        theme.currentTheme === 'light' ? 'widget-bg' : 'widget-bg-dark',
      )}
    >
      {children}
    </Stack>
  )
}

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',

  '>:not(video)': {
    pointerEvents: 'none',
    color: 'white',

    i: {
      color: 'white',
    },
  },
})

const widgetBGStyles = css({
  display: 'flex',
  width: '100%',
  height: '100%',
  backgroundPositionY: '-275px',
  backgroundRepeat: 'no-repeat',
})
